import React, {useState} from "react";
import "./_page-7.scss";
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";
import Tabs from "../../../Tabs/Tabs";

export default function Page7() {
    const name = "page7";

    const {data, setData, showDetailModel} = useVMStore();

    const dataPage4 = data["page4"];

    const types = ["Decken", "Dächer", "Fassaden", "Geländer", "Metallträger", "Türen & Fenster", "Vermaßung"];

    const value = [
        {
            val: "Standard",
            level: 1,
        },
        {
            val: "Hoch",
            level: 2,
        },
        {
            val: "Premium",
            level: 3,
        },
    ];

    const [curType, SetCurType] = useState<string>(types[0]);

    function getImageSrc(level: number, is3D: boolean = true, format: string = "png") {
        let _curType = curType.replaceAll("ä", "a").replaceAll("ü", "u").replaceAll("ß", "b");
        return process.env.REACT_APP_ROOT_DIRECTORY + `assets/${is3D ? "3" : "2"}d-images/${_curType}/${_curType} L${level}.${format}`;
    }

    return (
        <Form className="page-7 d-flex flex-column">
            {/* <div className="w-100 d-flex justify-content-center">
                <FormSelect data={types} value={curType} size="sm" setValue={SetCurType} />
            </div> */}
            <Tabs types={types} selecting={curType} onChangeTab={SetCurType} />
            <div className="d-flex justify-content-between mt-3 flex-column flex-md-row">
                {value.map((v) => (
                    <Form.Group
                        className="d-flex flex-column align-items-center w-100"
                        key={"page_7_op" + v.val}
                        controlId={"page_7_" + v.val}
                    >
                        <label>
                            {/*<img className='expand-btn' src="./assets/images/expand.svg" alt="expand"/>*/}
                            {dataPage4 !== "2D" && curType !== types[types.length - 1] ? (
                                <img
                                    src={getImageSrc(v.level)}
                                    alt={curType + " level " + v.level}
                                    onClick={() => showDetailModel(getImageSrc(v.level))}
                                />
                            ) : (
                                ""
                            )}
                            <img
                                src={getImageSrc(v.level, false)}
                                alt={curType + " level " + v.level}
                                onClick={() => showDetailModel(getImageSrc(v.level, false))}
                            />
                        </label>
                        <Form.Check
                            type="radio"
                            className="mb-3 mb-sm-0"
                            label={v.val}
                            value={v.val}
                            checked={data[name] === v.val}
                            onChange={(e) => {
                                setData(e.target.value, "page7");
                            }}
                        />
                    </Form.Group>
                ))}
            </div>
        </Form>
    );
    // return (
    //     <Form className="page-7 d-flex flex-column">
    //         <div className="w-100 d-flex justify-content-center">
    //             <FormSelect data={types} value={curType} size="sm" setValue={SetCurType} />
    //         </div>

    //         <div className="d-flex justify-content-between mt-3 flex-column flex-md-row">
    //             {value.map((v) => (
    //                 <Form.Group
    //                     className="d-flex flex-column align-items-center w-100"
    //                     key={"page_7_op" + v.val}
    //                     controlId={"page_7_" + v.val}
    //                 >
    //                     <label>
    //                         {/*<img className='expand-btn' src="./assets/images/expand.svg" alt="expand"/>*/}
    //                         {dataPage4 === "3D" && curType !== types[types.length - 1] ? (
    //                             <img
    //                                 src={getImageSrc(v.level)}
    //                                 alt={curType + " level " + v.level}
    //                                 onClick={() => showDetailModel(getImageSrc(v.level))}
    //                             />
    //                         ) : (
    //                             ""
    //                         )}
    //                         <img
    //                             src={getImageSrc(v.level, false)}
    //                             alt={curType + " level " + v.level}
    //                             onClick={() => showDetailModel(getImageSrc(v.level, false))}
    //                         />
    //                     </label>
    //                     <Form.Check
    //                         type="radio"
    //                         className="mb-3 mb-sm-0"
    //                         label={v.val}
    //                         value={v.val}
    //                         checked={data[name] === v.val}
    //                         onChange={(e) => {
    //                             setData(e.target.value, "page7");
    //                         }}
    //                     />
    //                 </Form.Group>
    //             ))}
    //         </div>
    //     </Form>
    // );
}
